import helper from "../helper";

export const queryProviceList = function(params) {
  return helper.get("/addr/queryProviceList", params);
};

export const queryCitysByProvinceId = function(params) {
  return helper.get("/addr/queryCitysByProvinceId", params);
};

export const queryContrysByCityId = function(params) {
  return helper.get("/addr/queryContrysByCityId", params);
};

export const queryProvinceGroup = function(params) {
  return helper.get("/addr/queryProvinceGroup", params);
};

export const queryAddressList = function() {
  return helper.get("/addr/queryAddressList");
};
